import { useMutation, useQueryClient } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import {
  AxiosResponseAndError,
  ResponseType,
} from "@/api/types/axiosResponseType";
import ApiRequest from "../ApiRequest";
import { z } from "zod";
import { dependenciesTaskSchema } from "@backend/src/schemas/taskSchema";
import { Task } from "./useTaskCreateMutation";
import { invalidateTaskRelatedQueries } from "@/utils/cacheInvalidation";

type TaskDependenciesResponse = ResponseType<Task>;

function useTaskDependenciesMutation(taskId?: string) {
  const queryClient = useQueryClient();
  const mutation = useMutation<
    AxiosResponseAndError<TaskDependenciesResponse>["response"],
    AxiosResponseAndError<TaskDependenciesResponse>["error"],
    z.infer<typeof dependenciesTaskSchema> & { taskId?: string }
  >({
    mutationFn: (data) =>
      ApiRequest.post<TaskDependenciesResponse>(
        `${requestURLs.task}dependencies/${taskId ?? data.taskId}`,
        data
      ),
    onSuccess: (res, variables) => {
      const targetTaskId = res?.data?.data?.taskId || variables.taskId || taskId;
      const targetProjectId = res?.data?.data?.projectId;
      void invalidateTaskRelatedQueries(queryClient, {
        taskId: targetTaskId,
        projectId: targetProjectId,
      });
    },
  });

  return mutation;
}

export default useTaskDependenciesMutation;
